import _ from 'lodash';

export const applyFilterCalculation = (selectedBanks, selectedCardType,selectedFeatures, salary, selectedCarType, allCardDetails, onlyContract, loanAmount) => {
  let filteredCardArray = [], filteredCardArrayFinal = allCardDetails;
  if (salary > 0) {
    filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
      return  salary >= cardDetail.minimumSalary;
    });
    filteredCardArrayFinal = filteredCardArray;
    filteredCardArray = [];
  }
  // if (!_.isUndefined(loanAmount) && loanAmount > 0) {
  //   filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
  //     return  cardDetail.maxLoanAmount >= loanAmount;
  //   });
  //   filteredCardArrayFinal = filteredCardArray;
  //   filteredCardArray = [];
  // }
  let typeCountObj = {}, autoLoanFeatureCountObj={}, carTypesCountObj={}, autoLoanBankCountObj={};

  if (!_.isEmpty(selectedCarType)) {
    filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
       return _.indexOf(cardDetail.carTypes, selectedCarType) >= 0;
    });
    filteredCardArrayFinal = filteredCardArray;
    filteredCardArray = [];
  } 

  if (!_.isEmpty(selectedCardType) && selectedCardType !== 'all') {
    filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
      return _.indexOf(cardDetail.type, selectedCardType) >= 0;
    });
    filteredCardArrayFinal = filteredCardArray;
    filteredCardArray = [];
  }

  if (!_.isEmpty(selectedFeatures)) {
    filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
      return  _.intersection(selectedFeatures, cardDetail.features).length === selectedFeatures.length;
    });
    filteredCardArrayFinal = filteredCardArray;
    filteredCardArray = [];
  }

  if (!_.isEmpty(selectedBanks)) {
    filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
      return _.indexOf(selectedBanks, cardDetail.bankName) >= 0;
    });
    filteredCardArrayFinal = filteredCardArray;
    filteredCardArray = [];
  }
  if(onlyContract){
    filteredCardArray = _.filter(filteredCardArrayFinal, (cardDetail) => {
      return cardDetail.contract;
    });
    filteredCardArrayFinal = filteredCardArray;
    filteredCardArray = [];
  }

  _.forEach(filteredCardArrayFinal, (item) => {
    _.forEach(item.type, (type) => {
      typeCountObj[type] = _.add(typeCountObj[type], 1);
    });
  });
  
  _.forEach(filteredCardArrayFinal, (item) => {
    //carTypesCountObj[item.carTypes] = _.add(carTypesCountObj[item.carTypes], 1);
     _.forEach(item.carTypes, (carType) => {
       carTypesCountObj[carType] = _.add(carTypesCountObj[carType], 1);
     });
  });
  
  _.forEach(allCardDetails, (item) => {
    autoLoanBankCountObj[item.bankName] = _.add(autoLoanBankCountObj[item.bankName], 1);
  });
  
  _.forEach(filteredCardArrayFinal, (item) => {
    _.forEach(item.features, (features) => {
      autoLoanFeatureCountObj[features] = _.add(autoLoanFeatureCountObj[features], 1);
    });
  });

  return {filteredCardArrayFinal: _.sortBy(filteredCardArrayFinal, [ 'name']), typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj};
};



// WEBPACK FOOTER //
// ./src/components/autoLoans/applyFilter.js